import React from "react";

export default function Calendar() {
  return (
    <div className="container-fluid py-5">
      <div className="row">
        <div className="col-12">
          <h1 className="mb-4">Calendar</h1>
          <p className="text-muted">View and manage your schedule</p>
        </div>
      </div>
    </div>
  );
}
